export const isDefined = <T>(value: T | null | undefined): value is T =>
	value !== null && value !== undefined;

export const delay = (ms: number) =>
	new Promise((resolve) => {
		setTimeout(resolve, ms);
	});
